import { render, staticRenderFns } from "./PricingInfo.vue?vue&type=template&id=556c93d4&scoped=true&"
import script from "./PricingInfo.vue?vue&type=script&lang=ts&"
export * from "./PricingInfo.vue?vue&type=script&lang=ts&"
import style0 from "./PricingInfo.vue?vue&type=style&index=0&id=556c93d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556c93d4",
  null
  
)

export default component.exports